<template>
	<div>
		<div v-if="terminal === 0">
			<WindowForAlert
				ref="windowForAlert"
				:btn-cancel="false"
				:title="title"
			>
				<div
					v-for="(item, index) in paramsList"
					:key="index"
					class="mb105x"
				>
					<span class="fsField">{{ item.name }}: </span>
					<span>{{ item.value }}</span>
				</div>
				<button slot="btmBtn" class="functionBtn" @click="hide()">
					{{ getLanguageStr("device220", "我知道了") }}
				</button>
			</WindowForAlert>
		</div>
		<div v-if="terminal === 1">
			<ResultDialog
				v-model="resultDialog"
				:confirm-button-color="stage.color.main"
				:confirm-button-text="getLanguageStr('device220', '我知道了')"
			>
				<div slot="title" class="taL fsLv6-mobile pl205x mb2x">
					{{ title }}
				</div>
				<div class="ml205x mr205x">
					<div
						v-for="(item, index) in paramsList"
						:key="index"
						class="mb2x"
					>
						<span class="fsField fsLv5-mobile"
							>{{ item.name }}:
						</span>
						<span class="fsField fsLv5-mobile">{{
							item.value
						}}</span>
					</div>
				</div>
			</ResultDialog>
		</div>
	</div>
</template>

<script>
import WindowForAlert from '@/components/common/ui/WindowForAlert.vue'
import { Dialog } from 'vant'
import { getLanguageStr } from '@/util/language'
export default {
  name: 'ParamResult',
  props: {},
  components: { ResultDialog: Dialog.Component, WindowForAlert },
  data () {
    return {
      stage,
      title: '',
      paramsList: [],
      resultDialog: false,
      resultMList: [],
      resultMTitle: '',
      terminal: null
    }
  },
  methods: {
    getLanguageStr,
    show (data) {
      const { list, title, terminal } = data
      this.title = title
      this.paramsList = list
      this.terminal = terminal
      if (terminal === 1) {
        this.$nextTick(() => {
          this.resultDialog = true
        })
      } else {
        this.$nextTick(() => {
          this.$refs.windowForAlert.show()
        })
      }
    },
    hide () {
      this.$refs.windowForAlert.hide()
    }
  },
  created () {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/view/device/device/part/ParamResult.vue